import { FormControl, MenuItem, Select, SxProps } from "@mui/material";
import React from "react";
import { Control, Controller } from "react-hook-form";

interface UseFormSelectProps {
  control: Control
  name: string
  items: UseFormSelectItem[]
  sx: SxProps
}

interface UseFormSelectItem {
  value: string
  label: string
}

export const UseFormSelect: React.FC<UseFormSelectProps> = ({
  control,
  name,
  items,
  sx = {}
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => (
        <FormControl size={'small'}>
          <Select
            {...field}
            sx={{
              fontFamily: 'Roboto',
              color: '#000000',
              fontStyle: 'normal',
              fontWeight: 'regular',
              fontSize: '14px',
              lineHeight: '24px',
              letterSpacing: '0.15px',
              paddingRight: '10px',
              ...sx,
            }}
          >
            {items.map((item, index) => (
              <MenuItem
                key={index}
                value={item.value}
                sx={{
                  fontSize: 14,
                  minHeight: 24,
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  )
}